import { render } from "./Offers.vue?vue&type=template&id=3020f67c&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=3020f67c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3020f67c"

export default script